import { Toggle } from '@/components/ui/Toggle.tsx'
import { TextField } from '@/components/ui/text-field.tsx'
import { useSettingsContext } from '@/modules/creator-settings/state/SettingsProvider'
import { SettingsOption } from '@/modules/creator-settings/ui/SettingsOption.tsx'
import { debounce } from '@/utils/helpers'

import { useMultipleBulkMessagesSettingsMutations } from '../hooks/use-multiple-bulk-messages-settings-mutations.ts'

export const MassMessagesSettings = () => {
  const {
    isLoading,
    multipleBulkMessagesAllowed,
    bulkMessagesGlobalCooldown,
    setSettingsData,
  } = useSettingsContext()

  const {
    setGlobalBulkMessageCooldownMutation,
    setAllowMultipleBulkMessagesMutation,
  } = useMultipleBulkMessagesSettingsMutations()

  const handleDebouncedOMMDelayChange = debounce((value: number) => {
    setGlobalBulkMessageCooldownMutation.mutate(value)
  }, 500)

  if (isLoading) {
    return null
  }

  return (
    <div className="bg-card mt-6 rounded-lg px-6">
      <SettingsOption
        title="Multiple Online Mass Messages simultaneously"
        description={
          <>
            Allow multiple online mass messages to be active at the same time.
            <br />
            <span className="font-bold">Warning:</span> If you don&apos;t set
            them up correctly, people could receive multiple messages within a
            short timeframe.{' '}
            <span className="font-bold">Use at your own risk.</span>
          </>
        }
        disableTopPadding={false}
      >
        <Toggle
          name="multiple-bulk-messages"
          onChange={(event) => {
            setAllowMultipleBulkMessagesMutation.mutate(event.target.checked)
          }}
          checked={multipleBulkMessagesAllowed}
        />
      </SettingsOption>

      <hr />

      <SettingsOption
        title="Exclude Fans that have received an Online Mass Message recently"
        description="People will not receive any mass message for the specified amount of hours after they have received one."
      >
        <TextField
          suffix={<span className="text-secondary-300">Hours</span>}
          type="number"
          showSuffixSeparator
          min={0}
          className="no-arrows text-secondary-500 w-24 rounded-md border p-2 outline-none"
          value={bulkMessagesGlobalCooldown}
          onChange={(event) => {
            setSettingsData((settings) => {
              return {
                ...settings,
                bulkMessagesGlobalCooldown: +event.target.value,
              }
            })
            handleDebouncedOMMDelayChange(+event.target.value)
          }}
        />
      </SettingsOption>
    </div>
  )
}
